import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Page } from 'src/common/routes';

const MobileMenuContainer = styled.div<{ isOpen: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background: rgba(255, 255, 255, 0.5);
  border: 1px solid rgba(255, 255, 255, 0.9);
  border-radius: 0px;
  backdrop-filter: blur(20px);
  z-index: 1000;
  transform: ${props => props.isOpen ? 'translateX(0)' : 'translateX(-100%)'};
  transition: transform 0.3s ease-in-out;
  padding: 20px;
  display: flex;
  flex-direction: column;
`;

const MenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 40px 40px;
  margin-bottom: 40px;
`;

const LogoContainer = styled.div`
  display: flex;
  align-items: center;
  width: 120px;
`;

const LogoImage = styled.img`
  width: 100%;
`;

const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CloseIcon = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15 5L5 15" stroke="#211747" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M5 5L15 15" stroke="#211747" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const MenuList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
`;

const MenuItem = styled.li`
  font-family: 'Inter', sans-serif;
  font-size: 1.6rem;
  font-weight: 500;
  color: #211747;
  padding: 8px 0;
  text-align: center;
`;

const MenuLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  transition: color 0.2s ease;
  display: block;
  width: 100%;

  &:hover {
    color: #AB9BED;
  }
`;

interface MobileHeaderMenuProps {
  isOpen: boolean;
  onClose: () => void;
}

const MobileHeaderMenu: React.FC<MobileHeaderMenuProps> = ({ isOpen, onClose }) => {
  return (
    <MobileMenuContainer isOpen={isOpen}>
      <MenuHeader>
        <LogoContainer>
          <Link to={`/${Page.Home}`}>
            <LogoImage src="/images/Logo.svg" alt="Kymera Logo" />
          </Link>
        </LogoContainer>
        <CloseButton onClick={onClose}>
          <CloseIcon />
        </CloseButton>
      </MenuHeader>
      <MenuList>
        <MenuItem>
          <MenuLink to={`/${Page.HowItWorks}`} onClick={onClose}>How it Works</MenuLink>
        </MenuItem>
        <MenuItem>
          <MenuLink to={`/${Page.Solutions}`} onClick={onClose}>Solutions</MenuLink>
        </MenuItem>
        <MenuItem>
          <MenuLink to={`/${Page.AboutUs}`} onClick={onClose}>About us</MenuLink>
        </MenuItem>
        <MenuItem>
          <MenuLink to={`/${Page.PilotProgram}`} onClick={onClose}>Pilot Program</MenuLink>
        </MenuItem>
      </MenuList>
    </MobileMenuContainer>
  );
};

export default MobileHeaderMenu; 